export default {
  dataApiConfig: {
    logging: {
      baseUrl:
        'https://dev.core-gateway.np.api-business.comcast.com/logging-api',
      sensitiveFields: null,
    },
    invite: {
      baseUrl: '/api',
      sensitiveFields: [
        'captchaToken',
        'emailAddress',
        'firstName',
        'lastName',
        'password',
        'securityAnswer',
        'securityQuestionDescription',
        'securityQuestionKey',
        'validationToken',
        'zipCode',
      ],
    },
  },
  //these info should be check again later with BE devs
  logContext: {
    appName: 'PrimaryInvite',
    appType: 'ClientApp',
    appVersion: process.env.REACT_APP_UI_VERSION,
    applicationId: 'invite-user-ui',
    apiKey: 'K06lPBT0UikuQyiwW6MQ72tB9N4YORL5nWTN92O8',
    environment: 'dev',
  },
  sessionDurationInMinutes: 20,
  globalNavConfig: {
    scriptUrl:
      'https://bsd-global-nav-ui-dev.np.digital.business.comcast.com/globalNav.js',
    environment: 'dev',
  },
};
